import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, Typography, Box, Divider } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SuccessMessage from 'core/components/SuccessMessage';
import { addMlmuserObj, setMlmuserOnboardModal, setMlmuserTandcModal } from 'store/slice/DmpSlice';
import { navigation } from 'menu-items';
import { useNavigate } from 'react-router-dom';
import {setPartnershipInitiationMode} from 'store/slice/EcomSlice';
import {setSelectedBottomMenu} from 'store/slice/EcomSlice';

export default function AlreadyOnboarded() {
    const navigate= useNavigate();
    const dispatch = useDispatch();
    const { inviteeMobileNumber, partnerObj, inviteeObj, mlmUserObj } = useSelector((state) => state.ecomslice.mlm);
    const close = () =>{
        window.location.href="/";
        // dispatch(setMlmuserOnboardModal(false));
        // dispatch(setPartnershipInitiationMode(false));
        // dispatch(setSelectedBottomMenu("HOME"));
    }
    return (
        <>
            <Grid container justifyContent="center" alignItems="center" sx={{ backgroundColor: 'white', padding: 1, borderRadius: 2 }}>
                <Grid item >
                    <Typography variant="h6">
                        Hello <Box component="span" sx={{ color: "primary.main", fontWeight: "bold", fontSize: 18 }}>{mlmUserObj && mlmUserObj.title}</Box>,
                    </Typography>
                    <Typography sx={{ paddingTop: 2 }}>
                        You are already our 'Business Associate'. Enjoy your Benefits being GnR 'Business Associate'.
                    </Typography>
                </Grid>

            </Grid>
            <Grid container justifyContent="center" alignItems="center" sx={{ paddingTop: 5 }}>
                <Grid item>
                    <Button variant="contained" onClick={() => close()}>OK</Button>
                </Grid>
            </Grid>

        </>
    )
}